export default function TiktokLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5204 3.19333C10.9974 2.5863 10.7091 1.80687 10.7092 1H8.34439V10.6444C8.32653 11.1665 8.10984 11.6611 7.74003 12.0238C7.37023 12.3866 6.87622 12.5892 6.36224 12.5889C5.27551 12.5889 4.37245 11.6867 4.37245 10.5667C4.37245 9.22889 5.64286 8.22556 6.95153 8.63778V6.18C4.31122 5.82222 2 7.90667 2 10.5667C2 13.1567 4.11225 15 6.35459 15C8.75765 15 10.7092 13.0167 10.7092 10.5667V5.67444C11.6681 6.37433 12.8194 6.74984 14 6.74778V4.34444C14 4.34444 12.5612 4.41444 11.5204 3.19333Z"
        fill="var(--text-primary-color)"
        className="path-fill"
      />
    </svg>
  );
}
